/* eslint-disable */
/**
 * Modelo de presentación y acciones del panel lateral.
 *
 * Estos métodos operan sobre la instancia de PanelLogic y conservan el
 * contrato del prototipo importado. No mantienen estado global propio.
 */
const logic = {
drawerVals(st) {
  const v = st.view || 'panel',
    closed = st.drClosed || {},
    set = o => () => this.setState(o);
  const it = (label, icon, on, onClick, tag, options = {}) => ({
    label,
    icon,
    onClick,
    bg: on ? 'rgba(232,80,20,0.22)' : 'transparent',
    bar: on ? 'oklch(0.68 0.17 45)' : 'transparent',
    color: on ? '#fff' : '#e4e9f0',
    fw: on ? 600 : 400,
    tag: tag || '',
    tagC: on ? 'oklch(0.8 0.14 60)' : '#5a667a',
    ...options
  });
  const tog = k => () => this.setState(s => ({
      [k]: !s[k]
    })),
    go = (view, extra) => () => this.setState({
      view,
      dpHov: null,
      fsHov: null,
      ...(extra || {})
    });
  const I = {
    why: 'M9.5 9a2.5 2.5 0 1 1 3.6 2.2c-.7.4-1.1 1-1.1 1.8V14M12 17.5v.5M3 12a9 9 0 1 0 18 0 9 9 0 1 0-18 0',
    grid: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
    simp: 'M4 4h16v6H4zM4 14h16v6H4z',
    cmp: 'M3 12h7M7 9l3 3-3 3M21 12h-7M17 9l-3 3 3 3',
    dep: 'M12 3v18M8 7l4-4 4 4M8 17l4 4 4-4',
    rng: 'M5 4h14v6H5zM5 14h14v6H5zM9 7h6M9 17h6',
    cmpc: 'M4 6h2M10 6h2M16 6h2M4 12h2M10 12h2M16 12h2M4 18h2M10 18h2M16 18h2',
    fs: 'M3 5h18v10H3zM7 19h10M12 15v4M7 10l3-2 3 3 4-4',
    bell: 'M6 16V11a6 6 0 0 1 12 0v5l2 2H4zM10 21h4',
    cal: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
    chk: 'M3 6l2 2 3-3M3 13l2 2 3-3M11 6h10M11 13h10M11 19h10'
  };
  const D = this.data,
    hasDepthData = typeof this.hasDepthData === 'function' && this.hasDepthData(),
    depthNoDataTooltip = this.props.translate?.('analytics_depth_no_measurements') || 'No hay tiempo medido ni alarmas con profundidad en el período solicitado.',
    vsSel = this.vsSel(st),
    pal = this.vsPal,
    pend = st.vsPend || vsSel,
    openVs = () => this.setState({
      drawer: true,
      drMode: 'vs',
      vsPend: null
    });
  const res = st.tRes || 'dia',
    secs = [['ana', 'Analítica', [[null, [it('General', I.grid, (v === 'panel' || v === 'cmp') && !st.simple, go('panel', {
      simple: false
    })), it('Simplificada', I.simp, v === 'panel' && !!st.simple, go('panel', {
      simple: true
    })), it('Comparar', I.cmp, v === 'vs', go('vs')), it('Causas', I.why, v === 'cz', go('cz')), ...(v === 'vs' ? [it('Seleccionar', I.chk, false, openVs, String(vsSel.length))] : [])]], ['Ajustes de vista', [it('Profundidad', I.dep, v === 'dep', hasDepthData ? go('dep') : undefined, '', hasDepthData ? {} : {
      disabled: true,
      tooltip: depthNoDataTooltip,
      color: '#5a667a'
    }), it('Mostrar rangos', I.rng, !!st.showRng, tog('showRng'), st.showRng ? 'ON' : 'OFF'), it('Compactar', I.cmpc, !!st.compact, tog('compact'), st.compact ? 'ON' : 'OFF')]]]], ['ali', 'Métricas de alimentación', [[null, [it('Feeder Score', I.fs, v === 'fs' && (st.fsMet || 'score') !== 'att', go('fs', {
      fsMet: 'score'
    })), it('Atención de alarmas', I.bell, v === 'fs' && st.fsMet === 'att', go('fs', {
      fsMet: 'att'
    }))]]]], ['tie', 'Tiempo', [['Resolución temporal', [['dia', 'Día'], ['sem', 'Semana'], ['mes', 'Mes']].map(([k, l]) => it(l, I.cal, res === k, set({
      tRes: k
    })))]]]];
  const cyc = (k, opts) => {
    const cur = st[k] || opts[0];
    return {
      v: cur,
      onClick: () => this.setState({
        [k]: opts[(opts.indexOf(cur) + 1) % opts.length]
      })
    };
  };
  const OR = 'oklch(0.66 0.19 42)';
  const vsBits = {
    drVs: st.drMode === 'vs',
    drMain: st.drMode !== 'vs',
    drBack: () => this.setState({
      drMode: null,
      vsPend: null
    }),
    openVsSel: openVs,
    vsChips: vsSel.map((ci, j) => ({
      n: D.cages[ci],
      c: pal[j],
      vs: j > 0
    })),
    vsPendChips: pend.map((ci, j) => ({
      n: D.cages[ci],
      c: pal[j],
      vs: j > 0,
      rm: () => this.setState(s => ({
        vsPend: (s.vsPend || vsSel).filter(x => x !== ci)
      }))
    })),
    vsHint: pend.length < 2 ? 'mín. 2 · máx. 4' : pend.length + ' de 4',
    vsApplyOp: pend.length < 2 ? 0.4 : 1,
    vsApply: () => {
      if (pend.length < 2) return;
      this.setState({
        vsSel: pend,
        vsPend: null,
        view: 'vs',
        drawer: false,
        drMode: null,
        vsHov: null,
        vsHovA: null,
        vsHovR: null
      });
    },
    vsList: D.cages.map((n, ci) => {
      const on = pend.includes(ci),
        full = pend.length >= 4 && !on;
      return {
        n,
        lab: on ? '✓ v/s' : '+ v/s',
        bg: on ? OR : 'transparent',
        bd: on ? OR : full ? 'rgba(58,69,88,0.5)' : 'rgba(184,193,206,0.3)',
        color: on ? '#fff' : full ? '#3a4558' : '#b8c1ce',
        click: () => {
          if (full) return;
          this.setState(s => {
            const p = s.vsPend || vsSel;
            return {
              vsPend: on ? p.filter(x => x !== ci) : [...p, ci]
            };
          });
        }
      };
    })
  };
  return {
    ...vsBits,
    drawerOn: !!st.drawer,
    gearBg: st.drawer ? 'rgba(232,80,20,0.18)' : 'transparent',
    toggleDrawer: () => this.setState(s => ({
      drawer: !s.drawer,
      drMode: null
    })),
    closeDrawer: () => this.setState({
      drawer: false,
      drMode: null
    }),
    drawerSecs: secs.map(([k, title, groups]) => ({
      title,
      open: !closed[k],
      chev: closed[k] ? '▾' : '▴',
      toggle: () => this.setState(s => ({
        drClosed: {
          ...(s.drClosed || {}),
          [k]: !(s.drClosed || {})[k]
        }
      })),
      groups: groups.map(([sub, items]) => ({
        sub: sub || '',
        hasSub: !!sub,
        items
      }))
    })),
    selAyuno: cyc('ayRes', ['Medio día', 'Día completo', '2 horas']),
    selVer: cyc('verPor', ['Todas', 'Jaulas activas', 'Con alarmas'])
  };
}
};

export default logic;
